import styled from 'styled-components'

const SHADOW = '0px 0px 5.24px 0px rgba(43,123,199,0.25)'
const SHADOW_MD = '0px 0px 10px 0px rgba(43,123,199,0.22)'
const CARD_CLIP = 'polygon(0% 8%, 8% 0%, 100% 0%, 100% 92%, 92% 100%, 0% 100%)'

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 2rem 2.5rem 1.25rem;

  @media (max-width: 720px) {
    padding: 1.5rem;
  }
`

export const PageIconBox = styled.div`
  width: 65px;
  height: 65px;
  border-radius: 15px;
  background: linear-gradient(223deg, rgba(0,200,248,1) 16%, rgba(104,94,252,1) 78%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 16px rgba(100, 98, 252, 0.22);
`

export const PageIconImg = styled.img`
  width: 33px;
  height: 33px;
  object-fit: contain;
`

export const PageTitleText = styled.h1`
  font-family: Poppins;
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
  line-height: 1.15;

  @media (max-width: 720px) {
    font-size: 1.6rem;
  }
`

export const PageSubtitleText = styled.p`
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 400;
  color: #000000;
  margin: 0;
  opacity: 0.55;
  line-height: 1.4;
`

export const FilterArea = styled.div`
  background: white;
  border-bottom: 1px solid #F0F1F3;
`

export const FilterTopRow = styled.div`
  padding: 1.4rem 2.5rem 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const FilterTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`

export const FilterTitle = styled.h2`
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: 600;
  color: #6B7280;
  margin: 0;
`

export const FilterCount = styled.span`
  font-family: Poppins;
  font-size: 0.68rem;
  font-weight: 700;
  color: white;
  background: #00A3FF;
  padding: 2px 9px;
  border-radius: 20px;
`

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 4.2rem;
  border-radius: 21px;
  background: white;
  box-shadow: ${SHADOW_MD};
  overflow: hidden;
  transition: box-shadow 0.18s;
  &:focus-within {
    box-shadow: 0px 0px 20px 0px rgba(43,123,199,0.35);
  }
`

export const SearchImg = styled.img`
  flex-shrink: 0;
  height: 20px;
  opacity: 0.4;
  margin: 0 1rem 0 1.5rem;
  pointer-events: none;
`

export const SearchInput = styled.input`
  flex: 1;
  height: 100%;
  padding: 0;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 300;
  color: #1A1D2E;
  border: none;
  outline: none;
  background: transparent;
  ::placeholder { color: #B1B8C5; font-weight: 300; }
`

export const SearchButton = styled.button`
  flex-shrink: 0;
  height: calc(100% - 12px);
  margin-right: 6px;
  padding: 0 1.8rem;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  color: white;
  background: #4465FE;
  border: none;
  border-radius: 13px;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #3354ee; }
`

export const CategoryBar = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 2.5rem;
  gap: 0.6rem;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`

export const CategoryTab = styled.button`
  display: flex;
  align-items: center;
  gap: 0.45rem;
  height: 48px;
  padding: 0 1.1rem;
  font-family: Poppins;
  font-size: 0.85rem;
  font-weight: ${props => props.active ? 600 : 500};
  color: ${props => props.active ? '#00A3FF' : '#4B5563'};
  background: ${props => props.active ? '#EEFCFF' : 'white'};
  border: 1.5px solid ${props => props.active ? '#A8E9F9' : 'transparent'};
  border-radius: 12px;
  box-shadow: ${props => props.active ? 'none' : SHADOW};
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.15s;
  &:hover {
    background: ${props => props.active ? '#EEFCFF' : '#F8FCFF'};
    border-color: ${props => props.active ? '#A8E9F9' : '#C8E8FF'};
  }
`

export const CategoryTabIcon = styled.span`
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  & img {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
`

export const CategoryTabCount = styled.span`
  font-family: Poppins;
  font-size: 0.72rem;
  font-weight: 600;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.active ? '#65E1FF' : '#E9F0FA'};
  color: ${props => props.active ? 'white' : '#9CA3AF'};
`

export const SortBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.45rem 2.5rem 0.6rem;
  border-top: 1px solid #F3F4F6;
`

export const ResultsInfo = styled.div`
  font-family: Poppins;
  font-size: 0.76rem;
  color: #9CA3AF;
`

export const ResultsCount = styled.span`
  font-weight: 700;
  color: #1A1D2E;
  margin-right: 2px;
`

export const SortGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
`

export const SortLabel = styled.span`
  font-family: Poppins;
  font-size: 0.72rem;
  color: #B0B7C3;
  margin-right: 2px;
`

export const SortButton = styled.button`
  height: 1.75rem;
  padding: 0 0.8rem;
  font-family: Poppins;
  font-size: 0.72rem;
  font-weight: ${props => props.active ? 700 : 400};
  color: ${props => props.active ? 'white' : '#6B7280'};
  background: ${props => props.active ? '#4465FE' : 'white'};
  border: 1px solid ${props => props.active ? '#4465FE' : '#E5E7EB'};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  &:hover {
    border-color: #4465FE;
    color: ${props => props.active ? 'white' : '#4465FE'};
  }
`

export const ContentArea = styled.div`
  padding: 1.75rem 2.5rem 3rem;
  min-height: 100%;
`

export const Section = styled.div`
  margin-bottom: 2.75rem;
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
`

export const SectionLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const SectionIconWrapper = styled.div`
  width: 2.2rem;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
  & img {
    width: 2rem;
    height: 2rem;
    object-fit: contain;
  }
`

export const SectionTitle = styled.h3`
  font-family: Poppins;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1A1D2E;
  margin: 0 0 0.1rem;
`

export const SectionDesc = styled.p`
  font-family: Poppins;
  font-size: 0.74rem;
  color: #9CA3AF;
  margin: 0;
`

export const SectionCount = styled.span`
  font-family: Poppins;
  font-size: 0.74rem;
  color: #9CA3AF;
  white-space: nowrap;
  background: #F3F4F6;
  padding: 3px 10px;
  border-radius: 20px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  grid-auto-rows: 470px;
  gap: 1.75rem;

  @media (max-width: 600px) {
    grid-template-columns: minmax(0, 1fr);
    grid-auto-rows: 450px;
  }
`

export const CardWrapper = styled.div`
  filter: drop-shadow(0px 0px 5.24px rgba(43,123,199,0.25));
  cursor: pointer;
  height: 100%;
  transition: filter 0.2s ease, transform 0.2s ease;
  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(43,123,199,0.35));
    transform: translateY(-3px);
  }
`

export const Card = styled.div`
  background: white;
  clip-path: ${CARD_CLIP};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const CardImage = styled.div`
  height: 225px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  background: #f0f4f8;

  @media (max-width: 600px) {
    height: 205px;
  }
`

export const CardImageEl = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

export const CardIconImg = styled.img`
  position: absolute;
  top: 10px;
  right: 5px;
  width: 68px;
  height: 68px;
  object-fit: contain;
  pointer-events: none;
`

export const CardImageBadge = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  font-family: Poppins;
  font-size: 0.56rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: white;
  background: rgba(0,0,0,0.35);
  border: 1px solid rgba(255,255,255,0.25);
  backdrop-filter: blur(4px);
  padding: 3px 9px;
  border-radius: 20px;
`

export const CardBody = styled.div`
  padding: 1rem 1.5rem 1.25rem 1.25rem;
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const CardMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.35rem;
`

export const CategoryTag = styled.span`
  font-family: Poppins;
  font-size: 0.62rem;
  font-weight: 700;
  color: ${props => props.color || '#3494FA'};
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const Duration = styled.span`
  font-family: Poppins;
  font-size: 0.65rem;
  font-weight: 500;
  color: #919191;
  display: inline-flex;
  align-items: center;
  gap: 3px;
`

export const CardTitle = styled.h3`
  font-family: Poppins;
  font-size: 1.2rem;
  font-weight: 700;
  color: ${props => props.color || '#3494FA'};
  margin: 0 0 0.5rem;
  line-height: 1.25;
`

export const CardDescription = styled.p`
  font-family: Poppins;
  font-size: 0.78rem;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 0.85rem;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
`

export const CardFooter = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-top: 0;
  margin-top: auto;
`

export const PriceLabel = styled.span`
  font-family: Poppins;
  font-size: 0.62rem;
  color: #6B7280;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  display: block;
  margin-bottom: 0.1rem;
`

export const PriceValue = styled.span`
  font-family: Poppins;
  font-size: 1.45rem;
  font-weight: 700;
  color: #1A1D2E;
  line-height: 1.1;
  display: block;
`

export const GroupPrices = styled.span`
  font-family: Poppins;
  font-size: 0.68rem;
  color: #6B7280;
  font-weight: 500;
  display: block;
  margin-top: 0.2rem;
`

export const ViewButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: Poppins;
  font-size: 0.88rem;
  font-weight: 500;
  color: #3494FA;
  transition: gap 0.15s;
  padding-right: 0.5rem;
  &:hover { gap: 9px; }
`

/* ── Formation à la une ─────────────────────────────────────── */

const HERO_CLIP = 'polygon(0 25px, 25px 0, 100% 0, 100% calc(100% - 25px), calc(100% - 25px) 100%, 0 100%)'

export const HeroSection = styled.div`
  margin-bottom: 2.75rem;
`

export const HeroSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1.1rem;
`

export const HeroLabel = styled.h2`
  font-family: Poppins;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1A1D2E;
  margin: 0;
`

export const HeroCardWrapper = styled.div`
  filter: drop-shadow(0px 0px 5.52px rgba(43,123,199,0.25));
  cursor: pointer;
  max-width: 860px;
  transition: filter 0.2s ease, transform 0.2s ease;
  &:hover {
    filter: drop-shadow(0px 0px 12px rgba(43,123,199,0.35));
    transform: translateY(-3px);
  }
`

export const HeroCard = styled.div`
  display: flex;
  height: 230px;
  background: white;
  clip-path: ${HERO_CLIP};
  overflow: hidden;

  @media (max-width: 720px) {
    height: auto;
    min-height: 28rem;
    flex-direction: column;
  }
`

export const HeroImage = styled.div`
  width: 48%;
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
  background: #f0f4f8;

  @media (max-width: 720px) {
    width: 100%;
    height: 12rem;
  }
`

export const HeroImageEl = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

export const HeroContent = styled.div`
  flex: 1;
  padding: 1.5rem 2.2rem 1.5rem 1.8rem;
  display: flex;
  flex-direction: column;

  @media (max-width: 720px) {
    padding: 1.25rem;
  }
`

export const HeroCategoryMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.55rem;
`

export const HeroCategoryTag = styled.span`
  font-family: Poppins;
  font-size: 0.62rem;
  font-weight: 700;
  color: ${props => props.color || '#3494FA'};
  text-transform: uppercase;
  letter-spacing: 0.1em;
`

export const HeroDuration = styled.span`
  font-family: Poppins;
  font-size: 0.68rem;
  font-weight: 500;
  color: #9CA3AF;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-transform: uppercase;
`

export const HeroTitle = styled.h2`
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 600;
  color: ${props => props.color || '#3494FA'};
  margin: 0 0 0.55rem;
  line-height: 1.15;
`

export const HeroDescription = styled.p`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
  line-height: 1.55;
  margin: 0;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const HeroFooter = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 1.1rem;
`

export const HeroPriceLabel = styled.span`
  font-family: Poppins;
  font-size: 0.58rem;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  display: block;
  margin-bottom: 0.1rem;
`

export const HeroPriceValue = styled.span`
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1A1D2E;
  line-height: 1.1;
`

export const HeroViewButton = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 500;
  color: #3494FA;
  padding-bottom: 3px;
  padding-right: 0.5rem;
`

export const BadgeContainer = styled.div``
export const Badge = styled.span``
export const CardImageOverlay = styled.div``
export const CardImageContent = styled.div``
export const CardImageTitle = styled.span``
export const CardImageBadgeBadge = styled.span``

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 0;
  gap: 0.75rem;
`

export const EmptyIcon = styled.div`
  font-size: 2.5rem;
  opacity: 0.3;
`

export const EmptyText = styled.p`
  font-family: Poppins;
  font-size: 0.88rem;
  color: #9CA3AF;
  margin: 0;
`
